export default __webpack_public_path__ + "static/img/code.72efc78.png";